'use client';

import { Video } from 'lucide-react';

import HLSVideoPlayer from '@/shared/components/hls-video-player/hls-video-player';
import { COPY } from '@/shared/constants/copies';

import { MAX_RECORDING_TIME } from '../constants';
import { useVideoRecording } from '../video-recording-provider';
import { ActionButtons, RECORDED_VIDEO_PLAYER_CLASS, VideoContainer } from './shared';

/**
 * Combined view for 'preview' and 'edit' states
 * Both show video with controls and retake/delete/save buttons
 */
export function ReviewView() {
	const { videoState, uiState } = useVideoRecording();

	// Use recordedVideoUrl for preview, savedVideoUrl for edit
	const videoSrc =
		uiState.state === 'edit' ? videoState.savedVideoUrl : videoState.recordedVideoUrl;

	return (
		<>
			<VideoContainer>
				{videoSrc && (
					<HLSVideoPlayer
						videoUrl={videoSrc}
						className={RECORDED_VIDEO_PLAYER_CLASS}
						videoClassName={uiState.isPortrait ? 'object-contain' : undefined}
					/>
				)}
			</VideoContainer>

			<ActionButtons variant="review" />

			{/* Time Limit Info Box - only shown in preview state */}
			{uiState.showTimeLimitInfo && (
				<div className="mt-3 animate-fade-in rounded-lg border border-blue-200 bg-blue-50 p-4">
					<div className="flex items-start gap-3">
						<div className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-blue-100">
							<Video className="h-4 w-4 text-blue-600" />
						</div>
						<div className="flex-1">
							<h4 className="mb-1 text-sm font-semibold text-blue-900">Recording Complete</h4>
							<p className="text-sm text-blue-700">
								{COPY.fields.videoRecorded(MAX_RECORDING_TIME)}
							</p>
						</div>
					</div>
				</div>
			)}
		</>
	);
}
